import { SuggestResult } from "types/api/search";
import Link from "next/link";
import ReactHtmlParser from "html-react-parser";
import SearchIcon from "@svg/search/search";
import ImageComponent from "@shared/components/image";
import { resolveProductImageSources } from "utils/product-image";

const SEARCH_SUGGEST_PLACEHOLDER =
  "https://cdn.faradars.org/wp-content/uploads/2023/02/01/grayrec.svg";

interface Props {
  searchProductResult: SuggestResult | [];
  searchKeyword: string[] | [];
  value: string;
  // eslint-disable-next-line no-unused-vars
  change: (e: string) => void;
  close: () => void;
  isAdmin?: boolean;
  showMinimal?: boolean;
  onExperimentSubmitter?: () => void;
}

const SearchSuggestResult: React.FC<Props> = ({
  searchProductResult,
  searchKeyword,
  value,
  change,
  close,
  isAdmin = false,
  showMinimal,
  onExperimentSubmitter,
}) => {
  const makeBold = (item: string, keyword: string) => {
    var re = new RegExp(keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "i");
    return item.replace(
      re,
      `<span className="text-zinc-800">${keyword}</span>`
    );
  };
  return (
    <div className="px-5">
      {searchKeyword?.length ? (
        <div
          className={` ${
            !Array.isArray(searchProductResult) &&
            !Array.isArray(searchProductResult) &&
            !showMinimal &&
            "border-b border-b-zinc-200 pb-2"
          } pt-6`}
        >
          {searchKeyword.map((d) => {
            return (
              <div
                className="flex  "
                key={`suggest-${d}`}
                onClick={() => {
                  change(d);
                }}
              >
                <SearchIcon className="cursor-pointer  text-zinc-500" />
                <p className="mb-4 cursor-pointer pr-2.5 text-xs font-normal text-zinc-500 ">
                  {ReactHtmlParser(makeBold(d, value))}
                </p>
              </div>
            );
          })}
        </div>
      ) : null}

      {isAdmin && !Array.isArray(searchProductResult) ? (
        <div className={showMinimal ? "" : `border-b border-b-zinc-200 py-6`}>
          {!showMinimal && (
            <div className="flex items-center justify-between">
              <p className="text-xs font-medium leading-5 text-fds-secondary">
                جستجو بین دسته‌بندی‌ها
              </p>
            </div>
          )}
          <div
            className={`flex flex-col flex-wrap gap-3 ${
              showMinimal ? "py-2" : "pt-4"
            }`}
          >
            {!Array.isArray(searchProductResult) &&
              searchProductResult?.categories.map((d) => (
                <p
                  key={`index-${d.title}`}
                  className="text-sm font-normal leading-5  text-zinc-500"
                >
                  در دسته{" "}
                  <Link
                    href={d.url}
                    onClick={() => {
                      close();
                      onExperimentSubmitter?.();
                    }}
                    className="text-blue-500"
                  >
                    {d.title}
                  </Link>
                </p>
              ))}
          </div>
        </div>
      ) : null}
      {!Array.isArray(searchProductResult) ? (
        <div className={showMinimal ? "" : "pt-6"}>
          {!showMinimal && (
            <p className="text-xs font-medium leading-5 text-fds-secondary">
              آموزش‌های پرمخاطب
            </p>
          )}
          <div className="flex flex-wrap gap-3 pt-6">
            {!Array.isArray(searchProductResult) &&
              searchProductResult.products.map((d) => {
                const imageSources = resolveProductImageSources(d);
                return (
                <div className="w-full" key={`index-${d.title}`}>
                  <Link
                    href={d.url}
                    onClick={() => {
                      close();
                      onExperimentSubmitter?.();
                    }}
                    className="flex gap-3  w-full items-center"
                    prefetch={false}
                  >
                    <ImageComponent
                      src={imageSources.src || SEARCH_SUGGEST_PLACEHOLDER}
                      fallbackSrcs={imageSources.fallbackSrcs}
                      width={40}
                      height={40}
                      alt={d.title}
                      className="!m-0 h-full object-cover !p-0 rounded-6"
                    />
                    <p
                      title={d.title}
                      className="truncate text-sm font-medium text-fds-primary"
                    >
                      {d.title}
                    </p>
                  </Link>
                </div>
              );
              })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default SearchSuggestResult;
